import { render } from "./Index.vue?vue&type=template&id=f2c08864&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=f2c08864&scoped=true&lang=css"

import exportComponent from "/Users/imac/projects/java/marketplace/wallet/wallet.console.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c08864"]])

export default __exports__